import {
    PHONE_NUMBER_SET,
    PHONE_NUMBER_ERROR,
    PHONE_NUMBER_CLEAR_ERROR,
  } from '../constants/payment/phoneConstants.js';
  
  const initialState = {
    phoneNumber: '',
    hasError: false,
  };
  
  export const phoneReducer = (state = initialState, action) => {
    switch (action.type) {
      case PHONE_NUMBER_SET:
        return {
          ...state,
          phoneNumber: action.payload,
          hasError: false,
        };
      case PHONE_NUMBER_ERROR:
        return {
          ...state,
          hasError: true,
        };
      case PHONE_NUMBER_CLEAR_ERROR:
        return {
          ...state,
          hasError: false,
        };
      default:
        return state;
    }
  };